import HmEventRegistry from './../model/HmEventRegistry';
const core_ajax_duplicate_interval = (window.ajax_calls_restrict_duplicate && !isNaN(window.ajax_calls_restrict_duplicate["core"])) ? window.ajax_calls_restrict_duplicate["core"] : 2;
const core_ajax_duplicate_prevent_methods = ["GET"];
/*
* CoreAjax is used by HmAjax.
* only difference latter handles the session validity.
*
*/
var CoreAjax = function(url,data,headers){
	var startTime = 0;
	var timeTakenInSecs = 0;
	var opts = {};

	let maskEnabled = false;
	let maskType = null;

	var availableMethods = ['GET','POST','PUT','DELETE'];
	var dataStr = "";
	
	if(typeof headers === 'object'){
		dataStr = data;
	}else{
		if(typeof data === 'object'){
			try{
				dataStr = JSON.stringify(data);
			}catch(e){}
		}else{
			dataStr = data;
		}
	}

	var calcResponseTime = function(){
		try{
			timeTakenInSecs = Math.round(((new Date().getTime() - startTime) / 1000)* 100) / 100;
			opts.timeTakenInSecs = timeTakenInSecs;		
		}catch(e){}
	}

	let pushDataToCache = function(data){
		try{
			if(window._core_ajax_requests_map && window._core_ajax_requests_map[url]){
				window._core_ajax_requests_map[url].data = data;
			}			
		}catch(e){
			console.error("error occurred while pushing data to cache :" , e);
		}
	}

	this.mask = function(inMaskType=null){
 		maskEnabled = true;
 		maskType = inMaskType;

 		return this;
 	}

	this.get = function(success, failure){
		this.connect('GET',success, failure);
	}

	this.post = function(success, failure){
		this.connect('POST',success, failure);
	}

	this.put = function(success, failure){
		this.connect('PUT',success, failure);	
	}

	this.delete = function(success, failure){
		this.connect('DELETE',success, failure);		
	}

	this.connect = function(method, success, failure){
		if(availableMethods.indexOf(method) === -1){
			//if method not defined, default is applied
			method = availableMethods[0];
		}

		var defaultParams  = {
			method: method,
			mode:'cors',
			redirect:'follow',
			credentials:'include',
			headers:{
				'Accept':  '*'  
			}
		};


		if(method === 'GET'){
			try{
				if(typeof data === "object" && Object.keys(data).length > 0){
					url += "?";
					for(var i in data){
						url += i + "=" + data[i] + "&";
					}
					url = url.substring(0,url.length-1);
				}
			}catch(e){
				console.error(e);
			}
		}else{
			defaultParams.headers["Content-Type"]="application/json";
			defaultParams.body = dataStr;	
		}


		try{
			if(typeof headers === "object" && Object.keys(headers).length > 0){		     
				for(var key in headers){
					defaultParams.headers[key] = headers[key];
				}		    
			}
		}catch(e){
			console.error(e);
		}


		/**
		* This temp Data will be used as model data for duplicate requests
		*/
		let tempData = null;

		/**
		* IMPORTANT: Check for duplicate requests and suppress them here.
		*/
		if(core_ajax_duplicate_prevent_methods && method && core_ajax_duplicate_prevent_methods.includes(method.toUpperCase())){
			window._core_ajax_requests_map = window._core_ajax_requests_map || {};
			let currentTime = Math.round(new Date().getTime() / 1000);
			if(window._core_ajax_requests_map[url] && window._core_ajax_requests_map[url].data && !isNaN(window._core_ajax_requests_map[url].time) && (currentTime - window._core_ajax_requests_map[url].time) <=  core_ajax_duplicate_interval){
				if(typeof success === "function"){
					success.apply(this,[window._core_ajax_requests_map[url].data, {"preloaded":true}]);	           		
				}

				console.log("Preventing duplicate request for url " + url +", preset interval :", core_ajax_duplicate_interval);
				return;
			}else{
				let tempObj = {
					time: currentTime,
					data: (window._core_ajax_requests_map[url] && window._core_ajax_requests_map[url].data) ? window._core_ajax_requests_map[url].data : null
				};
				window._core_ajax_requests_map[url] = tempObj;

				setTimeout(() => {
					delete window._core_ajax_requests_map[url];
				}, (core_ajax_duplicate_interval * 1000));
			}
		}

		startTime = new Date().getTime();

		if(maskEnabled){
			HmEventRegistry.fireEvent("SHOW_MASK", {maskType:maskType});	
		}
		fetch(url, defaultParams).then(response => {opts["status"] = response.status; opts["statusText"] = response.statusText; return response.json()}).then(	
			(result) => {
				calcResponseTime();
				pushDataToCache(result);
				
				try{
					if(typeof success === "function"){
						success.apply(this,[result, opts]);	
					}
				}catch(e){
					console.error("Error occurred while calling the success handler:",e);
				}	
				if(maskEnabled){
					HmEventRegistry.fireEvent("HIDE_MASK");
				}            
			},
			(error) => {
				calcResponseTime();

				try{
					if(typeof failure === "function"){
						failure.apply(this,[error, opts]);
					}
				}catch(e){
					console.error("Error occurred while calling the failure handler:",e);
				}
				if(maskEnabled){
					HmEventRegistry.fireEvent("HIDE_MASK");
				}
			}
			)
	}

}

export default CoreAjax;


// WEBPACK FOOTER //
// ./src/util/CoreAjax.js